import { formatarMoeda } from '@/utils'

export const navs = [
  {
    titulo: '',
    subtitulo: '',
    subtDetalhe: '',
    largura: 900,
    identidade: 'emenda',
    abreProximo: true,
    aberto: false
  }
]

export const dataFields = [
  {
    name: 'numero',
    title: 'Emenda nº',
    titleClass: 'text-right',
    dataClass: 'text-right'
  },
  {
    name: 'vereador.nome',
    title: 'Vereador'
  },
  {
    name: 'nome_orgao',
    title: 'Secretaria'
  },
  {
    name: 'descricao',
    title: 'Descrição'
  },
  {
    name: 'valor',
    title: 'Valor',
    titleClass: 'text-right',
    dataClass: 'text-right',
    callback(value) {
      return formatarMoeda(Number(value))
    }
  },
  {
    name: 'saldo',
    title: 'Saldo',
    titleClass: 'text-right',
    dataClass: 'text-right',
    callback(value) {
      return formatarMoeda(Number(value))
    }
  },
  {
    name: '__slot:actions',
    title: 'Detalhes',
    titleClass: 'text-center col-md-2',
    dataClass: 'text-center'
  }
]



// WEBPACK FOOTER //
// ./src/views/public/emendas_parlamentares/emendasGeral.js